
import { SistemaMixin } from "@/modules/Application";
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import Check from "vue-material-design-icons/Check.vue";
import EyeOff from "vue-material-design-icons/EyeOff.vue";
import TrashCan from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "app-novidades-admin",
  mixins: [SistemaMixin],
  components: {
    Pencil,
    Check,
    EyeOff,
    TrashCan,
  },
  data() {
    return {
      loading: false,
      erro: "",
      pacotes: [],
    };
  },
  mounted() {
    if (!this.isNuts) {
      this.$router.push({ name: "dashboard" });
      return;
    }
    this.$store.dispatch("setLoading", false);
    this.carregar();
  },
  methods: {
    async carregar() {
      this.loading = true;
      this.erro = "";
      try {
        const { data } = await this.$http.post("/novidades/admin/");
        this.pacotes = data.data || data || [];
      } catch (error) {
        this.erro =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar os pacotes de novidades.";
      } finally {
        this.loading = false;
      }
    },

    async togglePublicado(pacote) {
      try {
        if (pacote.publicado) {
          await this.$http.post("/novidades/admin/rascunho", { id: pacote.id });
          this.$toast.success("Pacote movido para rascunho.");
        } else {
          await this.$http.post("/novidades/admin/publicar", { id: pacote.id });
          this.$toast.success("Pacote de novidades publicado com sucesso.");
        }
        this.carregar();
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível alterar o status do pacote."
        );
      }
    },

    async excluir(pacote) {
      const result = await this.$swal.fire({
        icon: "warning",
        title: "Excluir este pacote?",
        text: `O pacote "${pacote.titulo}" será removido permanentemente.`,
        showCancelButton: true,
        confirmButtonText: "Sim, excluir",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) return;

      try {
        await this.$http.post("/novidades/admin/delete", { id: pacote.id });
        this.$toast.success("Pacote de novidades removido com sucesso.");
        this.carregar();
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível excluir o pacote."
        );
      }
    },

    formatDate(date) {
      if (!date) return "—";
      return this.$moment(date).format("DD/MM/YYYY");
    },
  },
  computed: {
    ...mapGetters(["isNuts"]),
  },
};
